import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CreateOrderSupplyMutationRequest, CreateOrderSupplyMutationResponse, CreateOrderSupplyPathParams } from "../../types/CreateOrderSupply";

/**
     * @summary Создание поставки
     * @link /api/orders/:orderId/supplies
     */
export async function createOrderSupply (orderId: CreateOrderSupplyPathParams["orderId"], data: CreateOrderSupplyMutationRequest, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<CreateOrderSupplyMutationResponse>["data"]> {
    const { data: resData } = await client<CreateOrderSupplyMutationResponse, CreateOrderSupplyMutationRequest>({
        method: "post",
        url: `/api/orders/${orderId}/supplies`,
        data,
        ...options
    });
    
    return resData;
};